import { makeAutoObservable, runInAction } from 'mobx';
import { getAppNotificationList } from '@/api';


class MessageCenterApp {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  displayList = [];
  tableLoading = false;

  //获取通知列表
  async getAppNotificationList(appId,envId, pageNum, pageSize) {
    runInAction(() => {
      this.tableLoading = true;
    });
    if (!appId || !envId ) {
      this.displayList = [];
      this.tableLoading = false;
    } else {
      let res;
      try {
        res = await getAppNotificationList(appId,envId, pageNum, pageSize);
        if (res && res.data && res.code === 200) {
          runInAction(() => {
            this.displayList = res.data;
          });
        }
      } catch (err) {}
      finally {
        runInAction(() => {
          this.tableLoading = false;
        });
      }

    }
  }


}

export default new MessageCenterApp();
